import { Component, ViewChild } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ModalComponent } from '../../components/modal/modal.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownService } from '../../services/dropdown.service';
import { HeaderComponent } from "../../components/header/header.component";
import { SearchInputComponent } from "../../components/search-input/search-input.component";
import { ButtonComponent } from "../../components/button/button.component";
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { TextInputComponent } from "../../components/text-input/text-input.component";
import { BulkUploadComponent } from "../../components/bulk-upload/bulk-upload.component";
import { PluralPipe } from '../../pipes/plural.pipe';
import { RolePermissionMappingService } from '../../services/role-permission-mapping.service';
import { SelectInputComponent } from "../../components/select-input/select-input.component";

@Component({
  selector: 'app-role-permission-mapping',
  imports: [HeaderComponent, SearchInputComponent, ButtonComponent, AgGridListComponent, ConfirmationPopupComponent, ModalComponent, TextInputComponent, BulkUploadComponent, ReactiveFormsModule, PluralPipe, FormsModule, SelectInputComponent],
  templateUrl: './role-permission-mapping.component.html',
  styleUrl: './role-permission-mapping.component.css'
})

export class RolePermissionMappingComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('bulk_modal') bulk_modal: any

  page_name = 'Role Permission Mapping';
  form: FormGroup;
  params: any = {};
  selected_ids: any = {}
  items: any[] = [];
  isSubmitting = false;

  columns: any = [
    { headerName: 'Sr.No', field: 'SrNo', },
    { field: 'Role.name', headerName: 'Role', filter: true, flex: 1, },
    { field: 'Permission.name', headerName: 'Permission', filter: true, flex: 1, },
    { field: 'University.name', headerName: 'School', filter: true, flex: 1, },
    { field: 'description', headerName: 'Description', filter: true, flex: 1, },
    { headerName: "Actions", sortable: false, flex: 1, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', }
  ];

  bulk_columns = [
    { column_name: 'Role', type: 'text', return_as: 'role_id', sample_value: 'Admin' },
    { column_name: 'Permission', type: 'text', return_as: 'permission_id', sample_value: 'AD' },
    { column_name: 'University', type: 'text', return_as: 'university_id', sample_value: 'AD' },
    { column_name: 'Description', type: 'text', return_as: 'description', sample_value: 'Mumbai' },
  ];

  actions(row: any) {
    let actions: any = []
    actions.push({ text: 'Update', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', function: this.open_form_modal.bind(this) })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.open_delete_modal.bind(this) })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public rpm: RolePermissionMappingService, public ar: ActivatedRoute, public ds: DropdownService) {
    this.form = this.fb.group({
      role_id: ['', [Validators.required]],
      permission_id: ['', [Validators.required]],
      university_id: [''],
      description: ['', [Validators.required]],
      is_active: [true]
    });
  }
  async ngOnInit() {
    await this.ds?.get_dropdown_list(['role', 'permission', 'university', 'sub_module', 'module']);
    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params }
    })
  }
  async get_list(filter?: any) {
    try {
      const res = await this.rpm.get_list(filter);
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;

      res.data = res.data.map((item: any, index: number) => ({
        ...item,
        SrNo: startindex + index + 1
      }));

      this.items = res;
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }
  async open_delete_modal(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_delete_modal?.open();
  }
  async delete() {
    let res = await this.rpm.delete(this.selected_ids.id);
    this.gs.toastr_shows_function(res?.message, 'Success', 'success');
    this.selected_ids = {};
    this.confirmation_delete_modal?.close()
    await this.get_list(this.params);
  }
  async bulk_delete(ids: any[]) {
    for (let id of ids) {
      let res = await this.rpm.delete(id);
    }
    this.gs.toastr_shows_function('Records deleted successfully', 'Success', 'success');
    await this.get_list(this.params);
  }
  async open_form_modal(item?: any) {
    this.selected_ids = item || {};
    if (this.selected_ids && this.selected_ids.id) {
      let response = await this.rpm.get(item.id);
      this.selected_ids = { ...response.data };
      this.form.patchValue({ ...this.selected_ids, });
    } else {
      this.selected_ids = {};
      this.form.reset();
    }
    this.form_modal?.open();
  }
  close_form_modal(): void {
    this.form_modal?.close();
  }
  async submit() {
    try {
      if (this.isSubmitting) {
        return;
      }
      if (this.form.invalid) {
        this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
        this.form.markAllAsTouched();
        return;
      }
      this.isSubmitting = true;
      let form_value = this.form.value;
      form_value.is_active = true
      if (this.selected_ids && this.selected_ids.id) {
        let update_response = await this.rpm.update(this.selected_ids.id, form_value);
        this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
      } else {
        let create_response = await this.rpm.add(form_value);
        this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
      }
      await this.get_list(this.params);
      this.close_form_modal();
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    } finally {
      this.isSubmitting = false;
    }
  }

  async bulk_upload(data: any, spinner: any) {
    try {
      const updatedData = data.map((item: any) => ({
        ...item,
        is_active: true
      }));
      await this.gs.bulk_form_submission(updatedData, this.rpm, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      console.error(error?.error?.message, '');
    }
  }
}
